import styled from '@emotion/styled';
import React from 'react';

interface Props {
	children: React.ReactNode;
}

const Wrapper = styled.div`
	height: 100%;

	.-top {
		text-align: end;
		padding-right: 11px;
		padding-bottom: 8px;
	}

	.H2-Grid {
		height: 100%;
	}
`;

const Page: React.FC<Props> = ({ children }) => {
	return <Wrapper>{children}</Wrapper>;
};

const TopBar: React.FC<Props> = ({ children }) => {
	return <div className="-top">{children}</div>;
};

export default Page;
export { TopBar };
